export var LoginResultError;
(function (LoginResultError) {
    LoginResultError["ACCOUNT_LOCKED"] = "ACCOUNT_LOCKED";
    LoginResultError["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    LoginResultError["TOO_MANY_REQUESTS"] = "TOO_MANY_REQUESTS";
    LoginResultError["UNKNOWN"] = "UNKNOWN";
})(LoginResultError || (LoginResultError = {}));
//# sourceMappingURL=login-result-error.enum.js.map